import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';

import SettingsGeneral from './SettingsGeneral';
import SettingsCamera from './SettingsCamera';
import SettingsAudio from './SettingsAudio';
import SettingsGuests from './SettingsGuests';

import { ReactComponent as SettingsIcon } from '../../../assets/icons/icon-settings-general.svg';
import { ReactComponent as CameraIcon } from '../../../assets/icons/icon-settings-camera.svg';
import { ReactComponent as AudioIcon } from '../../../assets/icons/icon-settings-audio.svg';
import { ReactComponent as GuestIcon } from '../../../assets/icons/icon-settings-user.svg';

import { WebRTCsdkService } from '../../../services/webrtcsdk-service';
import { container } from "tsyringe";
import { StyledTab, StyledTabs, TabPanel } from '../../tabs/StyledTabs';


const Settings = () => {

  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));

  const storedValue = parseInt(localStorage.getItem('settingsTab'));
  const [tabIndex, setTabIndex] = useState(isNaN(storedValue) ? 0 : storedValue);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    localStorage.setItem('settingsTab', newValue.toString());
  };

  useEffect(() => {
    console.log('webRTCsdkService init', webRTCsdkService);
  }, []);

  useEffect(() => {
    webRTCsdkService.settingsCameraVisible = ( tabIndex === 1)
  }, [tabIndex])

  return (
    <>
      <Box sx={{ bgcolor: '#ffffff', width: '100%' }}>
        <StyledTabs
          value={tabIndex}
          onChange={handleChange}
          aria-label="styled tabs example"
        >
          <StyledTab icon={<SettingsIcon className="settings" />} label="General" />
          <StyledTab icon={<CameraIcon />} label="Camera" />
          <StyledTab icon={<AudioIcon />} label="Audio" />
          {/* <StyledTab icon={<GuestIcon />} label="Guests" /> */}
        </StyledTabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <SettingsGeneral></SettingsGeneral>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <SettingsCamera></SettingsCamera>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <SettingsAudio></SettingsAudio>
      </TabPanel>
      {/* <TabPanel value={tabIndex} index={3}>
        <SettingsGuests></SettingsGuests>
      </TabPanel> */}
    </>
  );
}

export default Settings;